import React, { forwardRef } from 'react';
export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {}
const Select = forwardRef<HTMLSelectElement, SelectProps>(({
  className = '',
  ...props
}, ref) => {
  return <select className={`flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 ${className}`} ref={ref} {...props} data-id="element-166" />;
});
Select.displayName = 'Select';
export { Select };